// src/thunks/subscriptionThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';

// Base URL for your API
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Create customer async action
export const createCustomer = createAsyncThunk(
    'subscription/createCustomer',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/plan/create-customer`, {
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Handle payment async action
export const handlePayment = createAsyncThunk(
    'subscription/handlePayment',
    async ({ planId, customerId }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BASE_URL}/plan/subscribe`,
                { planId, customerId },
                {
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`,
                    }
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Fetch payment status async action
export const handleFatchPayment = createAsyncThunk(
    'subscription/handleFatchPayment',
    async (subscriptionId, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BASE_URL}/fatch/:${subscriptionId}`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Get Plans
export const getPlan = createAsyncThunk(
    'subscription/getPlan',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/plan`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);